import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { networkConnectedRef } from '../App';
import { logConsole, logTransaction } from '../common/log';
import { LogType } from '../models/log.model';
import { toastStatic } from '../providers/ToastProvider';

// Request
export const defaultRequestInterceptorSuccess = (config: InternalAxiosRequestConfig<any>) => {
  logConsole(LogType.Info, `${config.method} ${config.url}`);
  return config;
};
export const defaultRequestInterceptorFail = (error: any) => {
  toastStatic.errorToast(error);
  logTransaction(LogType.Error, `[HTTP_DEFAULT_REQ_FAIL] ${error}`);
  return Promise.reject(error);
};

// Response
export const defaultResponseInterceptorSuccess = (response: AxiosResponse<any, any>) => {
  return response;
};
export const defaultResponseInterceptorFail = (error: any) => {
  const errorMessage = error?.response?.data?.message;

  // Do not display toast on cancel
  if (axios.isCancel(error)) {
    return Promise.reject(error);
  }

  // Do not display toast when no network connected
  if (!networkConnectedRef) {
    return Promise.reject(error);
  }

  // Do not display toast on 401
  if (error?.response?.status !== 401) {
    if (errorMessage) {
      toastStatic.errorToast(errorMessage);
      logTransaction(LogType.Error, `[HTTP_DEFAULT_RES_FAIL] ${errorMessage}`);
    } else {
      if (axios.isAxiosError(error)) {
        // Only display errors on "foreground" requests, not on "background" requests
        if (!isBackgroundRequest(error?.config?.url)) {
          toastStatic.errorToast(error.message);
        }
      } else {
        toastStatic.errorToast(error);
      }
      logTransaction(LogType.Error, `[HTTP_DEFAULT_RES_FAIL] ${error}`);
    }
  }

  return Promise.reject(error);
};

const isBackgroundRequest = (url?: string) => {
  const backgroundUrls = [
    /\/api\/common\/technician\/v1\/clocking\/+/,
    /\/api\/system\/branch\/v2\/list\/+/,
    /\/api\/workshop\/repairOrder\/v1\/all\/+/,
    /\/api\/system\/typeCode\/v1\/list\/+/,
    /\/api\/common\/technician\/v1\/workcategory\/list\/+/,
    /\/api\/common\/mediaattachment\/v1\/attachment\/WorkshopVehicle\/[^/]+\/\d+\/thumbnail\/+/,
  ];
  let result = false;

  backgroundUrls.every((backgroundUrl) => {
    if (url?.match(backgroundUrl)?.length) {
      result = true;
      return false;
    }
    return true;
  });

  return result;
};
